module.exports = __webpack_public_path__ + "img/pennstate.300b996f.png";